// @flow
import * as React from 'react';
import { CloudDownloadOutlined } from '@ant-design/icons';
import { Input, Menu, Button, Dropdown } from 'antd';
import { connect } from 'react-redux';
import { PERMISSIONS, createPermitFunction } from '../../../Evolve/Utilities/permissions';
import { isAdmin } from 'Common';

const styles = {

  stack: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 25
  },

  heading: {
    flex: 1,
    margin: 0
  }
}

type Props = {
  searchTerm: string,
  userPermissions: [],
  onChangeSearch: () => void,
  onSubmitSearch: () => void,
  onClickNewProject: () => void,
  onClickExport: () => void
}

class Header extends React.PureComponent<Props> {

  render () {
    const {
      searchTerm,
      userPermissions,
      onClickNewProject,
      onSubmitSearch,
      onChangeSearch,
      onClickExport
    } = this.props;

    // DEBUG: Log user permissions
    console.log('🔍 Projects Header - User Permissions:', userPermissions);
    console.log('🔍 Projects Header - isAdmin() result:', isAdmin());
    
    // Create permit function with userPermissions baked in
    const permit = createPermitFunction(userPermissions);
    
    // Permission logic: if isAdmin, then check permit for export
    const isAdminUser = isAdmin();
    const isPermitted = permit('exports');
    const canExport = isAdminUser && isPermitted;
    
    console.log('🔍 Projects Header - permit(exports):', isPermitted);
    console.log('🔍 Projects Header - Final Can Export:', canExport);

    const exportMenu = (
      <Menu onClick={onClickExport}>
        <Menu.ItemGroup title='Projects'>
          <Menu.Item key="projects-excel">Export to Excel</Menu.Item>
          <Menu.Item key="projects-csv">Export to CSV</Menu.Item>
        </Menu.ItemGroup>
        <Menu.Divider />
        <Menu.ItemGroup title='Valuation Dates'>
          <Menu.Item key="valuation-dates-excel">Export to Excel</Menu.Item>
          <Menu.Item key="valuation-dates-csv">Export to CSV</Menu.Item>
        </Menu.ItemGroup>
      </Menu>
    );

    return (
      <div style={styles.stack}>

        <h1 style={styles.heading}>
          Projects
        </h1>

        <Input.Search
          value={searchTerm}
          onChange={onChangeSearch}
          onSearch={onSubmitSearch}
          placeholder="Search"
          enterButton
          style={{ width: 250 }}
        />

        {canExport && (

          <React.Fragment>

            <div style={{ width: 10 }} />

            <Dropdown overlay={exportMenu}>
              <Button>
                <CloudDownloadOutlined style={{ fontSize: 16, marginTop: 3 }} />
              </Button>
            </Dropdown>

          </React.Fragment>

        )}

        <div style={{ width: 10 }} />

        <Button type="primary" onClick={onClickNewProject}>
          New Project
        </Button>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log('🔍 Redux State - Full user object:', state.user);
  return {
    userPermissions: (state.user && state.user.permissions) || [],
  };
}

export default connect(mapStateToProps)(Header)
